const wait = (duration) => new Promise(resolve => setTimeout(() => resolve(), duration));

class ExecLoop {
    constructor(repeatInterval, callback) {
        this._repeatInterval = repeatInterval;
        this._callback = callback;

        this._running = false;
        this._waitPromise = null;
        this._callPromise = null;
    }

    start() {
        if (this._running) return;
        this._running = true;

        /*
         * If loop has been stopped and restarted before the
         * last execution finished, keep waiting for it
         */
        if (this._waitPromise === null) {
            this._exec();
        }
    }

    stop() {
        if (!this._running) return;
        this._running = false;
    }

    _exec() {
        this._waitPromise = wait(this._repeatInterval);
        this._callPromise = new Promise(resolve => resolve(this._callback()));

        this._waitPromise.then(() => {
            this._callPromise.catch(error => {
                console.error(error);
            }).finally(() => {
                if (this._running) {
                    this._exec();
                } else {
                    this._waitPromise = null;
                    this._callPromise = null;
                }
            });
        });
    }
}

export default ExecLoop;
